import {
  equals,
  find,
  groupBy,
  has,
  is,
  isEmpty,
  isNil,
  length,
  map,
  not,
  omit,
  pipe,
  prop,
  propEq,
  propOr,
  reject,
  head,
} from 'ramda';
import {
  dimensionValueDisplay,
  isRefAreaDimension,
  isTimePeriodDimension,
  parseDisplay,
} from '../dimension-utils';
import { CHORO, STACKED_BAR, STACKED_ROW, TYPES } from '../constants';

export const isNumber = input => {
  const value = Number(input);
  return not(isNil(value) || isNaN(value));
};

export const isPositiveNumber = input => {
  return isNumber(input) && Number(input) >= 0;
};

export const isNaturalInt = value => isNil(value) || /^\d+$/.test(String(value));

export const isChart = type => has(type, TYPES);

export const hasFocus = type => has(type, omit([CHORO], TYPES));

export const getDimensionsWithValues = data =>
  pipe(
    propOr([], 'dimensions'),
    reject(d => d.header || isEmpty(d.values || [])),
  )(data);

export const toState = artefact => prop('id', artefact);

export const getPropertyDimension = property => (data, state) => {
  const dimensionId = prop(property, state);
  const { dimensions = [] } = data || {};

  return find(propEq(dimensionId, 'id'), dimensions);
};

export const getGroupedDimensions = pipe(
  getDimensionsWithValues,
  groupBy(dimension => {
    if (isRefAreaDimension(dimension)) {
      return 'area';
    }
    if (isTimePeriodDimension(dimension)) {
      return 'time';
    }
    return 'other';
  }),
);

export const optionParser = option =>
  pipe(
    option => (is(Array, option) ? head(option) : option),
    option => (is(Object, option) ? prop('value', option) : option),
    option => (is(String, option) ? option : undefined),
  )(option);

export const artefactToOption = display => artefact =>
  isNil(artefact)
    ? undefined
    : {
        label: dimensionValueDisplay(parseDisplay(display))(artefact),
        value: prop('id', artefact),
      };

export const chartDimensionToOption =
  property =>
  ({ data, display }, state) =>
    pipe(getPropertyDimension(property), artefactToOption(display))(data, state);

export const chartDimensionOptions = ({ data, type, display }, typeValidator) => {
  if (!typeValidator(type)) {
    return [];
  }
  const dimensions = getDimensionsWithValues(data);
  if ((equals(type, STACKED_BAR) || equals(type, STACKED_ROW)) && length(dimensions) === 1) {
    return [];
  }
  return map(artefactToOption(display), dimensions);
};
